export const DOCUMENTS_AUDIO_FLAG = 'DOCUMENTS_AUDIO_UPLOAD'

export const AUDIO_EXTENSIONS = ['mpeg', 'mp3']

export const isCallRecordingsOffice = (customSettings) => customSettings?.callRecordingsAccess === true

export const isAudioKey = (key) => typeof key === 'string' && key.includes('.')
  && AUDIO_EXTENSIONS.includes(key.split('.').pop().toLowerCase())

export const isAudioResult = (data) => data?.kind === 'audio' && typeof data?.url === 'string'
